import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import AuthContext from "../../../context/auth/AuthContext";
import {
  cleanupPushImages,
  deletePushImage,
  uploadPushImage,
} from "../../../services/push-notifications";
import { pushNotificationKeys } from "../queryKeys";

const usePushImageActions = () => {
  const { tenant } = useContext(AuthContext);
  const tenantCode = tenant?.code;
  const queryClient = useQueryClient();
  const refreshImages = () =>
    queryClient.invalidateQueries({
      queryKey: pushNotificationKeys.images(tenantCode),
    });

  return {
    uploadImage: useMutation({
      mutationFn: uploadPushImage,
      onSuccess: refreshImages,
    }),
    deleteImage: useMutation({
      mutationFn: deletePushImage,
      onSettled: refreshImages,
    }),
    cleanupImages: useMutation({
      mutationFn: cleanupPushImages,
      onSuccess: refreshImages,
    }),
  };
};

export default usePushImageActions;
